import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export class ChannelService {
	public static channelSave(input: any) {
		return input.channel.channelId >= 0 ?
			Http.axios().put('/api/Channels/update', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				})
			:
			Http.axios().post('/api/Channels/add', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				});
	}

 public static channelGetByfilter(input: any = null) {
		input = (input != null) ? input : {getActiveOnly: true} 
	 return Http.axios().post('/api/Channels/getbyfilter', input, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}


	public static channelGetAll(input: any = null) {
		input = (input != null) ? input : { getActiveOnly: true }
		return Http.axios().post('/api/Channels/getall', input, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static channelGetDetail(id: any, code: any) {
		return Http.axios().get('/api/Channels/details/' + id + '?code=' + code, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static channelDelete(input: any) {
		return Http.axios().delete('/api/Channels/delete/' + input, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static channelGetFavourite(input: any) {
		return Http.axios().get('/api/Channels/getfavouritechannelbyuserid?userId=' + input.userId, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static channelGetNonFavourite(input: any) {
		return Http.axios().get('/api/Channels/getnonfollowedchannelbyuserid?userId=' + input.userId, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}